// extracted by mini-css-extract-plugin
module.exports = {"Picture":"Picture_Picture__1tzdD","isFallback":"Picture_isFallback__29wyj","Picture_asset":"Picture_Picture_asset__1CJcF","Picture___cover":"Picture_Picture___cover__30Ii7"};